import React from 'react';
import {
  Fingerprint,
  CreditCard,
  HowToVote,
  DirectionsCar,
  Flight,
  EmojiEvents,
  Description,
  AccountBalance,
  Business,
  School,
  LocalHospital,
  Home,
  WorkOutline,
  FamilyRestroom,
  Cake,
  MenuBook,
  Category,
  Assignment,
  AttachMoney,
  Gavel,
  VerifiedUser,
  Person,
  Receipt,
  AccountBalanceWallet,
  CardMembership,
  Badge,
  AdminPanelSettings,
  LocalShipping,
  Agriculture,
  Store,
  NaturePeople,
  Park,
  AccountBox
} from '@mui/icons-material';

// Icon mapping from database icon names to Material-UI components
export const getIconComponent = (iconName: string): React.ReactElement => {
  const iconMap: Record<string, React.ReactElement> = {
    // Identity Documents
    'fingerprint': <Fingerprint sx={{ fontSize: 48 }} />,
    'credit_card': <CreditCard sx={{ fontSize: 48 }} />,
    'how_to_vote': <HowToVote sx={{ fontSize: 48 }} />,
    'voter_id': <HowToVote sx={{ fontSize: 48 }} />,
    'directions_car': <DirectionsCar sx={{ fontSize: 48 }} />,
    'driving_license': <DirectionsCar sx={{ fontSize: 48 }} />,
    'driving_licence': <DirectionsCar sx={{ fontSize: 48 }} />,
    'drivinglicense': <DirectionsCar sx={{ fontSize: 48 }} />,
    'drivinglicence': <DirectionsCar sx={{ fontSize: 48 }} />,
    'dl': <DirectionsCar sx={{ fontSize: 48 }} />,
    'drive_eta': <DirectionsCar sx={{ fontSize: 48 }} />,
    'flight': <Flight sx={{ fontSize: 48 }} />,
    'passport': <Flight sx={{ fontSize: 48 }} />,
    'emoji_events': <EmojiEvents sx={{ fontSize: 48 }} />,
    'certificate': <EmojiEvents sx={{ fontSize: 48 }} />,
    'certificates': <EmojiEvents sx={{ fontSize: 48 }} />,
    'cert': <EmojiEvents sx={{ fontSize: 48 }} />,
    'workspace_premium': <EmojiEvents sx={{ fontSize: 48 }} />,
    'badge': <Badge sx={{ fontSize: 48 }} />,
    'account_box': <AccountBox sx={{ fontSize: 48 }} />,
    
    // Government & Services
    'account_balance': <AccountBalance sx={{ fontSize: 48 }} />,
    'government': <AccountBalance sx={{ fontSize: 48 }} />,
    'business': <Business sx={{ fontSize: 48 }} />,
    'gavel': <Gavel sx={{ fontSize: 48 }} />,
    'verified_user': <VerifiedUser sx={{ fontSize: 48 }} />,
    'admin_panel_settings': <AdminPanelSettings sx={{ fontSize: 48 }} />,
    
    // Education & Health
    'school': <School sx={{ fontSize: 48 }} />,
    'education': <School sx={{ fontSize: 48 }} />,
    'local_hospital': <LocalHospital sx={{ fontSize: 48 }} />,
    'hospital': <LocalHospital sx={{ fontSize: 48 }} />,
    'health': <LocalHospital sx={{ fontSize: 48 }} />,
    
    // Property & Financial
    'home': <Home sx={{ fontSize: 48 }} />,
    'property': <Home sx={{ fontSize: 48 }} />,
    'attach_money': <AttachMoney sx={{ fontSize: 48 }} />,
    'money': <AttachMoney sx={{ fontSize: 48 }} />,
    'account_balance_wallet': <AccountBalanceWallet sx={{ fontSize: 48 }} />,
    'wallet': <AccountBalanceWallet sx={{ fontSize: 48 }} />,
    'receipt': <Receipt sx={{ fontSize: 48 }} />,
    
    // Employment & Family
    'work_outline': <WorkOutline sx={{ fontSize: 48 }} />,
    'work': <WorkOutline sx={{ fontSize: 48 }} />,
    'employment': <WorkOutline sx={{ fontSize: 48 }} />,
    'family_restroom': <FamilyRestroom sx={{ fontSize: 48 }} />,
    'family': <FamilyRestroom sx={{ fontSize: 48 }} />,
    'person': <Person sx={{ fontSize: 48 }} />,
    'cake': <Cake sx={{ fontSize: 48 }} />,
    
    // Documents & Forms
    'description': <Description sx={{ fontSize: 48 }} />,
    'document': <Description sx={{ fontSize: 48 }} />,
    'documents': <Description sx={{ fontSize: 48 }} />,
    'menu_book': <MenuBook sx={{ fontSize: 48 }} />,
    'assignment': <Assignment sx={{ fontSize: 48 }} />,
    'card_membership': <CardMembership sx={{ fontSize: 48 }} />,
    
    // Business & Trade
    'local_shipping': <LocalShipping sx={{ fontSize: 48 }} />,
    'shipping': <LocalShipping sx={{ fontSize: 48 }} />,
    'agriculture': <Agriculture sx={{ fontSize: 48 }} />,
    'store': <Store sx={{ fontSize: 48 }} />,
    'shop': <Store sx={{ fontSize: 48 }} />,
    
    // Nature & Environment
    'nature_people': <NaturePeople sx={{ fontSize: 48 }} />,
    'park': <Park sx={{ fontSize: 48 }} />,
    
    // Default
    'category': <Category sx={{ fontSize: 48 }} />,
  };

  // Return the icon or default category icon
  return iconMap[iconName.toLowerCase()] || iconMap['category'];
};
